import { createChart, IChartApi, MouseEventParams } from "./lcharts/src/api/create-chart";
import { Time, LineData, BarData } from "../Models/lcharts/src/api/data-consumer";
import { ISeriesApi } from "../Models/lcharts/src/api/iseries-api";
import { LineWave, SerieColor } from './LineSerie';
import { WaveDrawer as WaveComputer, WaveType, DrawingAction, Wave, TrendDirection, WaveDirection } from '../Models/WaveComputer';
import { RetracementSettings, lineSettings } from './RetracementSettings';
import { ISerieMap } from "./Chart";
import { Series } from "./lcharts/src/model/series";
import { LineStyle } from "./lcharts/src/renderers/draw-line";
import { RetracementTypes } from '../Services/dg-hub-client.service';
import { ExtendedType } from "./lcharts/src/model/simple-line-options";
import { DrawingService } from 'src/app/Services/DrawingService';
import { Nominal } from "lightweight-charts";

export class RetracementIndicator {
  public fibonnaciLevels = [0, 0.236, 0.382, 0.5, 0.618, 0.786, 1];
  public retracementSettings: RetracementSettings;
  constructor(public drawingService:DrawingService) { };

  private _targetChart: IChartApi;
  public get targetChart(): IChartApi {
    return this._targetChart;
  }
  public set targetChart(value: IChartApi) {
    this._targetChart = value;
  }

  public waveType:RetracementTypes = null;

  public fibonacciLevelsSeries: ISeriesApi<"Line">[] = [];
  public baseLine: ISeriesApi<"Bar">;

  public pregenerateFibonancciLevels() {
    this.fibonacciLevelsSeries = [];

    let levels = this.retracementSettings.currentLevels(this.waveType);
    for (let l = 0; l < levels.length; l++) {
      let isExtended = levels[l].isExtended;
      let settings: lineSettings = {
        color: levels[l].color,
        lineStyle: LineStyle.NOLINE,//isExtended ? LineStyle.NOLINE : (levels[l].style)?Number(levels[l].style):LineStyle.Solid,
        lineWidth: (levels[l].width)?Number(levels[l].width):1,
        extendedStyle: (levels[l].style)?Number(levels[l].style):LineStyle.Solid
      }

      this.fibonacciLevelsSeries.push(
        this.targetChart.addLineSeries(LineWave.fibbonaciSerieOptions(levels[l].color as SerieColor, settings, isExtended, levels[l].isExtended, levels[l].extensionType))
      );
    }

  }

  lastbaseValue: number;
  lastTimeStart: Time;
  lastTimeEnd: Time;
  lastDiffValue:number;


  public lastRanges: lastRanges = null;
  public isActive:boolean = false;
  public startBaseVal:number;
  public endBaseVal:number;
  public color:string;
  public addFibonacciSectionTimeRange(selected?: Series<"Bar" | "Candlestick" | "Area" | "Line" | "Histogram">, time?: Time, reinit?: boolean) {
    // let waves = waveComputer.getAllWaves();

    if(reinit && !this.isActive)
    {
      return;
    }


    if (!reinit) {


      let serieData = selected.getData();

      let colors = this.drawingService.mapSeriesMap.get(selected.serieIndex);

      this.color = colors.color
      let serieDataItems = serieData.getItems();


      let selectedInit = serieDataItems.find(v => {
        return v.time.timestamp == time;
      })

      let index = serieDataItems.indexOf(selectedInit);

      let startPoint = serieDataItems[index];
      let endPoint = serieDataItems[index + 1];

      if(startPoint==undefined){
        debugger;
        return;
      };




      let diffValue = startPoint.value[0] - endPoint.value[0];

      this.startBaseVal = startPoint.value[0];
      this.endBaseVal = endPoint.value[0];


      if (diffValue == 0) {
        return;
      }


      this.lastbaseValue = (this.waveType == RetracementTypes.DOWNWAVE) ? endPoint.value[0] : startPoint.value[0];



      this.lastDiffValue = Math.abs(diffValue);
      this.lastTimeStart = startPoint.time.timestamp;
      this.lastTimeEnd = endPoint.time.timestamp;

      this.waveType = (diffValue<0) ? RetracementTypes.UPWAVE:RetracementTypes.DOWNWAVE;


    }

    let currentRanges: lastRanges = { startTime: this.lastTimeStart, endTime: this.lastTimeEnd, baseValue: this.lastbaseValue }

    if (
      !reinit &&
      this.lastRanges != null &&
      this.lastRanges.baseValue == currentRanges.baseValue &&
      this.lastRanges.startTime == currentRanges.startTime &&
      this.lastRanges.endTime == currentRanges.endTime
    ) {
      this.removeLevels();
      this.isActive = false;
      return;
    }

    this.lastRanges = currentRanges;
    let levels = this.retracementSettings.currentLevels(this.waveType);




    if(!this.generated)
    {
      this.pregenerateFibonancciLevels();
      this.generated = true;
    }






    let startBase: BarData[] = [{ time: this.lastTimeStart,
      open: this.startBaseVal,
       high: (this.startBaseVal>this.endBaseVal)?this.startBaseVal:this.endBaseVal,
       low: (this.startBaseVal>this.endBaseVal)?this.endBaseVal:this.startBaseVal,
       close: this.endBaseVal,
      }];
   // let endBase: LineData = { time: this.lastTimeStart, value: this.endBaseVal };
  //  let baseLineData = [startBase, endBase];
    this.baseLine = this.targetChart.addBarSeries({
      thinBars: true,
      upColor: this.color,
      downColor: this.color,
      openVisible: false,
      priceLineVisible: false,
      lastValueVisible: false,
  });

    this.baseLine.setData(startBase);

    let base = this.baseLine.getSerieIndex();



    for (let i = 0; i < levels.length; i++) {

      if (levels[i].levelValue != null) {

        let factor = (this.waveType == RetracementTypes.DOWNWAVE)?-1:1;

        let val = this.lastbaseValue +factor*(this.lastDiffValue * levels[i].levelValue)
        let start: LineData = { time: this.lastTimeStart, value: val };
        let end: LineData = { time:  this.lastTimeEnd, value: val };
        let data: LineData[] = [start, end];

        this.fibonacciLevelsSeries[i].setData(data);

        this.drawingService.excludeService.addToVerticalMap(this.fibonacciLevelsSeries[i].getSerieIndex(),base);
      }

    }
this.selectedSerie = selected
 this.drawingService.activeRetracements.excludesService.activeBars.set(base,this.selectedSerie);
  this.isActive = true;
    //   //console.log(selectedWave);

  }

  public selectedSerie;
  public generated:boolean = false;
  public removeLevels() {
    //this.fibonacciLevelsSeries[i].r
    this.removeSeries();
    this.pregenerateFibonancciLevels();
    this.lastRanges = null;
  }

  public getPoint(x:number, y:number): LineData {
    return { time: x as Time, value: y };
  }


  public redraw()
  {


    let startBase: BarData[] = [{ time: this.lastTimeStart,
      open: this.startBaseVal,
       high: (this.startBaseVal>this.endBaseVal)?this.startBaseVal:this.endBaseVal,
       low: (this.startBaseVal>this.endBaseVal)?this.endBaseVal:this.startBaseVal,
       close: this.endBaseVal,
      }];
   // let endBase: LineData = { time: this.lastTimeStart, value: this.endBaseVal };
  //  let baseLineData = [startBase, endBase];
    this.baseLine = this.targetChart.addBarSeries({
      thinBars: true,
      upColor: this.color,
      downColor: this.color,
      openVisible: false,
      priceLineVisible: false,
      lastValueVisible: false,
  });

    this.baseLine.setData(startBase);

    this.pregenerateFibonancciLevels();

    for (let i = 0; i < this.retracementSettings.currentLevels(this.waveType).length; i++) {

      if (this.retracementSettings.currentLevels(this.waveType)[i].levelValue != null) {

        let factor = (this.waveType == RetracementTypes.DOWNWAVE)?-1:1;
        let val = this.lastbaseValue + factor*(this.lastDiffValue * this.retracementSettings.currentLevels(this.waveType)[i].levelValue)
        let start: LineData = { time: this.lastTimeStart, value: val };
        let end: LineData = { time: this.lastTimeEnd, value: val };
        let data: LineData[] = [start, end];

        this.fibonacciLevelsSeries[i].setData(data);

        this.drawingService.excludeService.addToVerticalMap(this.fibonacciLevelsSeries[i].getSerieIndex(),this.baseLine.getSerieIndex());

      }

    }
  //  this.drawingService.activeRetracements.excludesService.activeBars.set(this.baseLine.getSerieIndex(),selected);
  }




  public updateSettings(retracementSettings: RetracementSettings) {
    this.retracementSettings = retracementSettings;
  }

  public removeSeries() {

    try{

      if(this.targetChart && this.baseLine)
      {
         this.targetChart.removeSeries(this.baseLine);
         this.drawingService.excludeService.removeFromCartessianMap(this.baseLine.getSerieIndex());
      }

    }
    catch(e)
    {
      //console.log(e);
    }
        this.fibonacciLevelsSeries.forEach(v => {
      try{
        this.targetChart.removeSeries(v);
      }
      catch(e)
      {
        //console.log(e);
      }
    })
  }
}

export interface IFibbonaciRanges {
  start: LineData,
  end: LineData
}

export interface lastRanges {
  startTime: Time,
  endTime: Time,
  baseValue: number
}
